var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.526,
    height: 43.526,
    viewBox: "0 0 43.526 43.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353",
    transform: "translate(21.846 2.383) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3441",
    "data-name": "Path 3441",
    d: "M1015.356,629.253l11.184,11.184a1.566,1.566,0,0,1,0,2.212h0a1.566,1.566,0,0,1-2.218,0l-11.179-11.179-10.762,10.753a1.567,1.567,0,0,1-2.217,0h0a1.566,1.566,0,0,1,0-2.213l10.757-10.757L1000.169,618.5a1.563,1.563,0,0,1,0-2.21h0a1.563,1.563,0,0,1,2.21,0l10.757,10.757,11.195-11.185a1.562,1.562,0,0,1,2.21,0h0a1.563,1.563,0,0,1,0,2.21Z",
    transform: "translate(-999.71 -615.4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b827a76960846446c208e1ad273de1ff.svg";
export { ForwardRef as ReactComponent };